import { render, staticRenderFns } from "./OverviewTab.vue?vue&type=template&id=7f8bca04"
import script from "./OverviewTab.vue?vue&type=script&lang=js"
export * from "./OverviewTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports